import React, { useEffect, useRef, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useNavigate } from '../../../../../../components/Navigate';
import { NavigateBefore, ThumbUp as ThumbsUpIcon } from '@mui/icons-material';
import cx from 'classnames';
import SliderContext from './context'
import ShowDetailsButton from './ShowDetailsButton'
import Mark from './Mark'
import './Item.scss'
import recommendedIcon from '../../../../../../content/icons/recommended-white.svg'

const Item = ({ content, rowKey }) => {

  const navigate = useNavigate();
  const itemRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = itemRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const onViewSlide = (content) => {
    navigate(`/content?k=${content.KeyId}`);
  }

  return (
    <SliderContext.Consumer>
      {({ onSelectSlide, currentSlide, elementRef }) => {
        const isActive = currentSlide && currentSlide.KeyId === content.KeyId;
        return (
          <div
            ref={(node) => {
              itemRef.current = node;
              if (elementRef) elementRef.current = node;
            }}
            style={{
              backgroundImage: isVisible ? `url(${content.thumbUrl})` : 'none'
            }}
            className={cx('item', {
              'item--open': isActive,
            })}
          >
            <span className="itemTitle" onClick={() => onViewSlide(content)} >{content.Title} {content.RecommendedForUser ? <img src={recommendedIcon} className={'title-icon'} /> : null} {content.HasUserRating ? <ThumbsUpIcon  className={'title-icon'} /> : null}</span>
            <ShowDetailsButton rowKey={rowKey} onClick={() => onSelectSlide(content)} />
            {content.RunningTime ? <span className="itemTime">{content.RunningTime}</span> : <span></span>}
            {isActive && <Mark />}
          </div>
        );
      }}
    </SliderContext.Consumer>
  );
}
export default Item;
